export default __webpack_public_path__ + "static/media/animated-clock.312dd893.gif";